<template>
    <section class="landing-page">
        <Hero />
        <Tabs v-if="isLoggedIn" v-slot="tabsProps">
            <Tab @tabMounted="tabsProps.onTabMounted"
                 :activeTab="tabsProps.activeTab"
                 :id="recommendedTabId"
                 :title="$t('LandingPage.tabs_recommended_title')">
                <Recommended />
                <TotemButton
                    class="landing-page__browse-all-button"
                    size="medium"
                    color="primary"
                    @click="goToAllSubjectAreas"
                    :label="$t('LandingPage.browse_all')"
                >
                </TotemButton>
            </Tab>
            <Tab @tabMounted="tabsProps.onTabMounted"
                 :activeTab="tabsProps.activeTab"
                 :title="$t('LandingPage.tabs_my_learning_title')">
                <StudyPlans />
            </Tab>
            <Tab @tabMounted="tabsProps.onTabMounted"
                 :activeTab="tabsProps.activeTab"
                 :title="$t('LandingPage.tabs_in_progress_title')">
                <UncompletedCourses />
            </Tab>
            <Tab @tabMounted="tabsProps.onTabMounted"
                 :activeTab="tabsProps.activeTab"
                 :title="$t('LandingPage.tabs_completed_title')">
                <CompletedCourses />
            </Tab>
        </Tabs>
        <div v-else class="page-content page-content--no-padding-top">
            <Recommended />
        </div>
        <ModalAddToNewWatchlist/>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import CompletedCourses from 'views/user/CompletedCourses'
    import UncompletedCourses from 'views/user/UncompletedCourses'
    import Recommended from 'components/landingpage/tabs/Recommended'
    import StudyPlans from 'components/landingpage/tabs/StudyPlans'
    import Tab from 'components/landingpage/Tab'
    import Tabs from 'components/landingpage/Tabs'
    import { viewTypes } from 'store/modules/search'
    import ModalAddToNewWatchlist from 'components/shared/modals/ModalAddToNewWatchlist'
    import Hero from 'components/landingpage/hero/Hero'

    export default {
        name: 'landing-page',
        components: {
            StudyPlans,
            UncompletedCourses,
            CompletedCourses,
            Recommended,
            Tab,
            Tabs,
            ModalAddToNewWatchlist,
            Hero
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                userInfo: 'User/getUserInfo',
                viewTypes: 'Search/viewTypes'
            }),
            showWatchlistModal () {
                return this.isLoggedIn && this.userInfo?.subordinatesCount && this.sharedWatchlistModalShown === false
            }
        },
        methods: {
            goToAllSubjectAreas () {
                this.$store.dispatch('Search/setMainPackage', null)
                this.$router.push({ 'name': 'all-packages-all-content' })
            }
        },
        data () {
            return {
                recommendedTabId: 'tab-recommended'
            }
        },
        provide () {
            return {
                recommendedTabId: this.recommendedTabId
            }
        },
        async created () {
            if (this.isLoggedIn) {
                await this.$store.dispatch('loadUserData')
            }
            this.$store.dispatch('Search/disableSearch')
            this.$store.dispatch('Search/setViewType', viewTypes.all)
            this.$store.dispatch('Search/setQuery', null)
            this.$store.dispatch('Search/clearAllFilters', null)
            this.$store.dispatch('Search/setMainPackage', null)
        }
    }
</script>

<style lang="scss" scoped>
    .landing-page {
        .landing-page__browse-all-button {
            margin: 40px auto;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>
